// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZSyAx8ZnH_7gXzPsAxYN{display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%}", "",{"version":3,"sources":["webpack://./src/Account/Credential/RetrievingCredentials.scoped.scss"],"names":[],"mappings":"AAAA,sBACI,YAAA,CACA,qBAAA,CACA,sBAAA,CACA,kBAAA,CACA,WAAA","sourcesContent":[".loadingContainer {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100%;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loadingContainer": "ZSyAx8ZnH_7gXzPsAxYN"
};
module.exports = ___CSS_LOADER_EXPORT___;
